import {  MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS, MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL } from '../actions/myStable'

const initialState = {
    submitOk: null
}

export default function reducer(state = initialState, action) {
    switch(action.type) {
        case MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS:
            return { ...state, submitOk: true }
        case MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL:
            return { ...state, submitOk: false }
        default:  return state;
    }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/myStableEmailUnsubscribe.js